import { render, staticRenderFns } from "./PaginationNoneLayout.vue?vue&type=template&id=6bd0c238"
import script from "./PaginationNoneLayout.vue?vue&type=script&lang=js"
export * from "./PaginationNoneLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports